/**
 * A class that visualizes the mouse position within a tilemap. Call its update method from the
 * scene's update and call its destroy method when you're done with it.
 */

 import Phaser from 'phaser'

 export default class MouseTileMarker {
    private scene: Phaser.Scene
    private map: Phaser.Tilemaps.Tilemap
   private preview: Phaser.GameObjects.Image
   private outline: Phaser.GameObjects.Graphics

    constructor(scene: Phaser.Scene, map: Phaser.Tilemaps.Tilemap, tileIndex: number) {
      const tileset = map.tilesets[0]
      if (!tileset) {
        throw new Error('MouseTileMarker requires a tilemap with at least one tileset')
      }

      const localTileId = tileIndex - tileset.firstgid
      if (localTileId < 0) {
        throw new Error(`Tile index ${tileIndex} does not belong to the map tileset`)
      }

      const sourceX = tileset.tileMargin + (localTileId % tileset.columns) * (tileset.tileWidth + tileset.tileSpacing)
      const sourceY = tileset.tileMargin + Math.floor(localTileId / tileset.columns) * (tileset.tileHeight + tileset.tileSpacing)
      const frameName = `mouse-tile-preview-${tileIndex}`
      const texture = scene.textures.get('tiles')

      if (!texture.has(frameName)) {
        texture.add(frameName, 0, sourceX, sourceY, tileset.tileWidth, tileset.tileHeight)
      }

      this.map = map;
      this.scene = scene;

      this.preview = scene.add
        .image(0, 0, 'tiles', frameName)
        .setOrigin(0.5)
        .setAlpha(0.6)
        .setTint(0x6ec8ff)
        .setBlendMode(Phaser.BlendModes.SCREEN)
        .setDepth(1000)

      this.outline = scene.add.graphics()
      this.outline.lineStyle(2, 0xff4f78, 0.7)
      this.outline.strokeRect(-map.tileWidth / 2, -map.tileHeight / 2, map.tileWidth, map.tileHeight)
      this.outline.setDepth(1001)
    }
  
    update(): void {
      const pointer = this.scene.input.activePointer
      const worldPoint = pointer.positionToCamera(this.scene.cameras.main) as Phaser.Math.Vector2
      const pointerTileXY = this.map.worldToTileXY(worldPoint.x, worldPoint.y)
      const snappedWorldPoint = this.map.tileToWorldXY(pointerTileXY.x, pointerTileXY.y)
      this.preview.setPosition(
        snappedWorldPoint.x + this.map.tileWidth / 2,
        snappedWorldPoint.y + this.map.tileHeight / 2,
      )
      this.outline.setPosition(
        snappedWorldPoint.x + this.map.tileWidth / 2,
        snappedWorldPoint.y + this.map.tileHeight / 2,
      )
    }
  
    destroy(): void {
      this.preview.destroy()
      this.outline.destroy()
    }
  }